import { render, staticRenderFns } from "./ReportRemarks.vue?vue&type=template&id=0ab69ec0&scoped=true&"
import script from "./ReportRemarks.vue?vue&type=script&lang=js&"
export * from "./ReportRemarks.vue?vue&type=script&lang=js&"
import style0 from "./ReportRemarks.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ReportRemarks.vue?vue&type=style&index=1&id=0ab69ec0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab69ec0",
  null
  
)

export default component.exports
import {QExpansionItem,QItem,QItemSection,QIcon,QBanner,QBtn,QItemLabel,QTable,QTr,QTh,QTd,QCheckbox} from 'quasar'
component.options.components = Object.assign({QExpansionItem,QItem,QItemSection,QIcon,QBanner,QBtn,QItemLabel,QTable,QTr,QTh,QTd,QCheckbox}, component.options.components || {})
